module.exports = __webpack_public_path__ + "assets/img/3.e8478843.png";